module.exports = __webpack_public_path__ + "img/tddg-2.60f319bd.jpg";